import { DismissablePromptsClients_viewer_dismissablePrompts as DismissablePromptFields } from '@ms/yammer-graphql';

import { DismissablePrompt } from '../../../state/types';

export const processDismissablePrompt: (value: DismissablePromptFields) => DismissablePrompt = (value) => ({
  id: value.promptKey,
  isDismissed: value.isDismissed,
});
